import { render, staticRenderFns } from "./paper-citation-popup.html?vue&type=template&id=1153d008&scoped=true&"
import script from "./paper-citation-popup.js?vue&type=script&lang=js&"
export * from "./paper-citation-popup.js?vue&type=script&lang=js&"
import style0 from "./paper-citation-popup.scss?vue&type=style&index=0&id=1153d008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1153d008",
  null
  
)

export default component.exports